import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCheckCircle } from "react-icons/fa";
import "./Terms.css";
import Header from "./Header";
const TermsConditions = () => {
  return (
    <div>
      <Header />
      <div
        className="background-image"
        style={{
          backgroundImage: "url('/images/image9.jpeg')",
        }}
      ></div>

      <div className="container-fluid terms" style={{ padding: "7%" }}>
        <h2 className="fw-bold text-secondary border-bottom pb-2">
          TERMS & CONDITIONS
        </h2>
        <p className="text-muted mb-4">
          Kindly take a printout of the Terms & Conditions, sign, and submit it
          along with a copy of the payment receipt cum booking confirmation
          acknowledgment at the time of occupying the booked venue.
        </p>

        <div className="mt-4">
          {/* 1. Permitted Uses */}
          <h5 className="fw-bold mt-4">1. Permitted Uses</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Venue bookings are{" "}
            <span className="text-danger fw-bold">NOT ALLOWED</span> for
            marriages, political meetings, or campaigns. All other bookings are
            permitted only through the online booking system.
          </p>

          {/* 2. Government Priority & Cancellation Rights */}
          <h5 className="fw-bold mt-4">
            2. Government Priority & Cancellation Rights
          </h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            In case of urgent requirements from the government or its
            departments, the venue management reserves the right to cancel any
            advance bookings on any date or venue. Customers will be informed of
            such cancellations, and the full amount paid will be refunded via
            online mode.
          </p>

          {/* 3. Advance Booking & Cancellation Policy */}
          <h5 className="fw-bold mt-4">
            3. Advance Booking & Cancellation Policy
          </h5>
          <p className="mb-2">
            <FaCheckCircle className="text-success me-2" />
            Advance bookings for events are allowed up to 180 days from the date
            of booking. Cancellation charges apply for confirmed bookings as
            follows:
          </p>
          <ul className="ms-4">
            <li>
              <strong>90 days before the event date</strong> 20% of the rental
              amount.
            </li>
            <li>
              <strong>60 days before the event date:</strong> 30% of the rental
              amount.
            </li>
            <li>
              <strong>30 days before the event date:</strong> 50% of the rental
              amount.
            </li>
            <li>
              <strong>Less than 30 days before the event date:</strong> 100% of
              the rental amount.
            </li>
          </ul>

          {/* 4. Payment and Refund Process */}
          <h5 className="fw-bold mt-4">4. Payment and Refund Process</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            All payments for venue bookings (rent, security deposit, and
            applicable taxes such as 18% GST on rent) are to be made via online
            payment. In case of a failed booking where the amount is debited,
            customers should contact their respective bank for refunds. All
            types of bank cards and net banking options are accepted.
          </p>

          {/* 5. Venue Occupation & Vacating */}
          <h5 className="fw-bold mt-4">5. Venue Occupation & Vacating</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            For successful bookings, customers must contact the venue manager
            for occupation and vacating procedures and strictly adhere to the
            terms and conditions. The security deposit will be refunded to the
            customer’s registered bank account after deducting electrical
            charges, damage charges, or other applicable fees, following
            sufficient time for estimation.
          </p>

          {/* 6. Occupancy Timing */}
          <h5 className="fw-bold mt-4">6. Occupancy Timing</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The venue can be occupied one hour before the booked time slot. The
            allotted space must be used solely for the purpose specified during
            booking, and no grievances regarding the allotted purpose will be
            entertained.
          </p>

          {/* 7. Event Organizer Responsibilities */}
          <h5 className="fw-bold mt-4">7. Event Organizer Responsibilities</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The authorized event organizer must remain at the venue until the
            event is completed and is responsible for ensuring the smooth
            functioning of the event without any untoward incidents.
          </p>

          {/* 8. Move-In / Move-Out Hours */}
          <h5 className="fw-bold mt-4">8. Move-In / Move-Out Hours</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The normal hours for move-in and move-out will be as permitted at
            the time of booking application.
          </p>

          {/* 9. Event Timing Adherence */}
          <h5 className="fw-bold mt-4">9. Event Timing Adherence</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The time for commencing and ending the event must strictly adhere to
            the allotment conditions. Failure to comply may result in additional
            rent charges proportional to the final billing.
          </p>

          {/* 10. Displays and Banners */}
          <h5 className="fw-bold mt-4">10. Displays and Banners</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Displays, booths, easels, or other items are not allowed in lobbies
            or corridors without prior written request and approval. Political
            banners or posters are strictly prohibited on the premises.
          </p>

          {/* 11. Hanging Restrictions */}
          <h5 className="fw-bold mt-4">11. Hanging Restrictions</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Banners, drapes, or other objects shall not be hung from ceilings,
            conduits, light fixtures, sprinkler pipes, or other piping
          </p>

          {/* 12. Venue Alterations */}
          <h5 className="fw-bold mt-4">12. Venue Alterations</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            No changes, alterations, repairs, painting, staining, or actions
            that alter the finish, appearance, or contours of the venue are
            permitted.
          </p>
          <h5 className="fw-bold mt-4">13. Decoration Approval:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Decorators or event organizers must submit decoration and setup
            plans in writing to the venue management for approval prior to
            undertaking any décor activities.
          </p>

          <h5 className="fw-bold mt-4">14.Entrances and Pathways:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Entrances must be kept clear of debris, and no vehicles (cars,
            trucks, etc.) are allowed to park near entrances except for loading
            and unloading. Pathways, passageways, halls, stairways, and exits
            must remain unobstructed at all times.
          </p>

          <h5 className="fw-bold mt-4">15. Outdoor Displays:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            No displays or exhibits are allowed outside the venue without prior
            approval from the venue management.
          </p>

          <h5 className="fw-bold mt-4">16. Electrical Wiring:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            No electrical wiring is permitted except by authorized venue
            personnel.
          </p>
          <h5 className="fw-bold mt-4">17. Animals at Events:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Animals are prohibited unless they are part of the event program. In
            such cases, proper care must be taken to maintain cleanliness and
            prevent foul odors, ensuring the safety of spectators.
          </p>
          <h5 className="fw-bold mt-4">18. Sharing of Allotted Space:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The allotted space cannot be shared with others for conducting or
            organizing any event or function.
          </p>
          <h5 className="fw-bold mt-4">19. Special Equipment Restrictions:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The entry of special equipment (e.g., cranes, carts, lift trucks)
            into the venue is prohibited.
          </p>

          <h5 className="fw-bold mt-4">20. VIP and Storage Areas:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            VIP and storage utility rooms are not included in the allotted space
            and are reserved exclusively for venue management use. No goods,
            equipment, or furniture are allowed in these areas without prior
            approval.
          </p>

          <h5 className="fw-bold mt-4">21. Sound Regulation:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The venue management retains the right to regulate the volume of any
            sound (e.g., music, voice, special effects) if it interferes with
            other users or is deemed offensive or in violation of the terms of
            service.
          </p>

          <h5 className="fw-bold mt-4">22. Complaints and Concerns:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            All concerns or complaints should be reported to the venue caretaker
            or manager for necessary action.
          </p>
          <h5 className="fw-bold mt-4">23. Security Requirements:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The event organizer will be invoiced for the required number of
            security guards, determined by the venue management based on the
            event details provided.
          </p>
          <h5 className="fw-bold mt-4">24. Equipment Operation:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Only authorized venue technicians are permitted to operate
            audio-visual (A/V) equipment or other venue equipment. The organizer
            will be invoiced for any technician fees.
          </p>

          <h5 className="fw-bold mt-4">25. Additional Facilities:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Only feasible and manageable facilities can be provided at the
            venue, subject to additional charges as determined by the venue
            management.
          </p>
          <h5 className="fw-bold mt-4">26. Cancellation After Confirmation:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            If the organizer cancels the event after confirmation, only 50% of
            the hiring charges paid will be refunded.
          </p>

          <h5 className="fw-bold mt-4">27. Non-Transferable Allotment:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Venue allotments are non-transferable.
          </p>
          <h5 className="fw-bold mt-4">28. Management Cancellation Rights:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The venue management may cancel any allotment at any time due to
            priority bookings, unforeseen circumstances (e.g., repairs,
            administrative emergencies), or other reasons.
          </p>

          <h5 className="fw-bold mt-4">29. Damage Responsibility:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            No damage should be caused to the venue or its surroundings. If any
            damage occurs, the organizing agency or individual will be
            responsible for the cost, which will be deducted from the security
            deposit.
          </p>

          <h5 className="fw-bold mt-4">30. Food and Beverage Restrictions:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Outside food, soft drinks, or other items are not permitted to be
            sold on the premises. Alcoholic beverages are strictly prohibited.
          </p>

          <h5 className="fw-bold mt-4">
            31. Power Supply for Venue Operations:
          </h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Air conditioning and other systems will operate subject to the
            availability of power supply from the local electricity provider.
            During power cuts, essential systems (e.g., PA system, fans,
            lighting) will be supported as feasible.
          </p>

          <h5 className="fw-bold mt-4">32. Permitted Events:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The venue is intended for cultural, social, spiritual, and
            educational functions only. Political meetings or campaigns are not
            permitted.
          </p>

          <h5 className="fw-bold mt-4">33. Event Closing Time:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The maximum closing time for events is 10 PM, as per local
            regulations.
          </p>

          <h5 className="fw-bold mt-4">34. Cleanliness and Damage Fines:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />A fine of Rs. 5,000/-
            will be charged if the venue or its premises are not maintained in a
            neat and clean condition or if the stage/premises are damaged,
            extended, or modified. The actual cost of damages will also be
            charged.
          </p>

          <h5 className="fw-bold mt-4">35. Loss or Theft Disclaimer:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The venue management is not responsible for any loss or theft during
            the event. Customers are advised to take care of their belongings.
          </p>
          <h5 className="fw-bold mt-4">36. Cooking Restrictions:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Only one gas cooking kit is allowed on the premises.
          </p>

          <h5 className="fw-bold mt-4">37. Carpeting Requirement:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The client must carpet both sides of the corridors of the allotted
            floor without fail.
          </p>

          <h5 className="fw-bold mt-4">
            38. Submission of Booking Confirmation:
          </h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            The client must submit a copy of the online booking confirmation
            within 24 hours to the venue office.
          </p>
          <h5 className="fw-bold mt-4">39. No Postponement or Preponement:</h5>
          <p className="mb-3">
            <FaCheckCircle className="text-success me-2" />
            Once the booking is confirmed, postponement or preponement of the
            event is not allowed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
